// VideoHeader.js
import '../../../static/VideoHeader.css';

const VideoHeader = ({ activeVideo, completionStatus = {}, onMarkComplete }) => {
    if (!activeVideo) return null;

    const isCompleted = Boolean(completionStatus?.[activeVideo.id]);
    const handleMarkComplete = () => {
        if (typeof onMarkComplete === 'function') {
            onMarkComplete(activeVideo.id);
        }
    };

    return (
        <div className="video-player__header">
            <div className="video-player__title-section">
                <h3 className="video-player__title" title={activeVideo.title}>
                    {activeVideo.title}
                </h3>
            </div>
            <VideoActions
                isCompleted={isCompleted}
                onMarkComplete={handleMarkComplete}
            />
        </div>
    );
};

const VideoActions = ({ isCompleted, onMarkComplete }) => (
    <div className="video-actions">
        {!isCompleted && (
            <button
                type="button"
                className="action-btn action-btn--complete"
                onClick={onMarkComplete}
                aria-label="Mark lesson as complete"
            >
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    className="action-btn__icon"
                    aria-hidden="true"
                >
                    <path
                        d="M13.3334 4L6.00008 11.3333L2.66675 8"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
                <span className="action-btn__label">Mark Complete</span>
                <span className="action-btn__label action-btn__label--short">Done</span>
            </button>
        )}
    </div>
);

export default VideoHeader;